module.exports = __webpack_public_path__ + "static/media/rudy-fr.2eb51c36.webp";